import React from "react";
import { ComponentI } from "../../../../types";
import Card from "../../../../componentLibrary/Card";
import Input from "../../../../componentLibrary/Input";
import ExternalTextEditor from "../../../../componentLibrary/ExternalTextEditor";

export default function ToggleTextContentCard({
  component,
  handleContentChange,
}: {
  component: ComponentI;
  handleContentChange: (id: string, field: string, value: string) => void;
}) {
  return (
    <Card>
      <div className="space-y-2">
        <Input
          value={component.content.title}
          onChange={(e) =>
            handleContentChange(component._id, "title", e.target.value)
          }
          label="Title"
          placeholder="Enter title here..."
        />
        <ExternalTextEditor
          value={component.content.body}
          handleChange={(value) =>
            handleContentChange(component._id, "body", value)
          }
          placeholder="Enter the text content here..."
          label="Body"
        />
      </div>
    </Card>
  );
}
